import React, {Component} from 'react';

import './Header.css';
import connect from "react-redux/es/connect/connect";
// import * as motion from "motion/react-client";
// import { motion } from "framer-motion";
// import { animate, scroll, stagger, delay } from "https://cdn.jsdelivr.net/npm/motion@latest/+esm";
// import { animate, scroll, stagger, delay } from "https://cdn.jsdelivr.net/npm/motion@latest/+esm";

// import { animate, scroll, stagger } from "motion";
import { motion } from "motion/react";

class Header extends Component {

    constructor(props) {

        super(props);
        this.state = {}
    }

    render() {

        const {comp: {data}} = this.props;


        // const { animate, scroll } = Motion
        // var animate = Motion.animate;
        // var stagger = Motion.stagger;
        // var delay = Motion.delay;
        // animate(".mvp .selection", { opacity: 1, y: [80, 0] }, { delay: stagger(1.06) });

        // delay(function () {
          // animate(".logos-cont", { scale: 1 }, { ease: "circInOut", duration: 1.2 })
        // }, 0.10);

        return (
            <div className='header'>
                {data && (data.logoBg || (data.sponsorsBg && data.sponsorsTop)) ? (
                    <div>
                        {data.sponsorsBg && data.sponsorsTop ? (data.sponsorsLink && data.sponsorsLink != '') ? (
                            <a href={data.sponsorsLink} target="_blank">
                                <div className={'logos-cont'}>
                                    <img src={data.sponsorsBg.file} className={'pl-logo logo-image sponsors'}/>
                                </div>
                            </a>
                        ) : (
                            <div className={'logos-cont'}>
                                <img src={data.sponsorsBg.file} className={'pl-logo logo-image sponsors'}/>
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </div>
        );
    }
}


const mapStateToProps = (state, ownProps) => {

    const things = state.default;
    return {
        ...ownProps,
        comp: things.competition,
        locale: things.locale
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
